import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/SideBar.css';
import {
  FaUsers,
  FaRegCopy,
  FaEnvelopeOpenText,
  FaEnvelope,
  FaLinkedin,
  FaWhatsapp,
  FaCalendarAlt,
  FaPhoneAlt,
  FaTachometerAlt, FaFacebookF, FaInstagram, FaSignal, FaCogs, FaUser, FaLock, FaPhone
} from 'react-icons/fa';
import { SiMeta } from 'react-icons/si';
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";  // Ant Design
// import logo from '../../images/logo.png';

function SideBar({ isOpen }) {
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation(); // to detect active route

  const handleToggle = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (
      location.pathname.startsWith("/templates") ||
      location.pathname.startsWith("/email-campaign")
    ) {
      setOpenMenu("email");
    }
    if (
      location.pathname.startsWith("/linkedin-campaign")
    ) {
      setOpenMenu("linkedin");
    }
    if (
      location.pathname.startsWith("/whatsapp-templates") ||
      location.pathname.startsWith("/whatsapp-campaign")
    ) {
      setOpenMenu("whatsapp");
    }
  }, [location.pathname]);

  return (
    <nav className={`sidebar-wrapper shadow-md ${isOpen ? 'show' : 'hide'}`}>
      <div className="sidebar-inner d-flex flex-column">

        {/* 1. Logo Section */}
        <div className="sidebar-logo p-3">
          <img src="/images/logo.jpg" alt="Logo" className="img-fluid" />
        </div>

        {/* 2. Menu Section */}
        <div className="sidebar-menu flex-grow-1 overflow-auto px-3">
          <ul className="list-unstyled mt-3">

            <li>
              <a
                href="/admin-dashboard"
                className={`text-decoration-none d-block py-2 ${isActive('/admin-dashboard') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                User List
              </a>
            </li>
            <li>
              <a
                href="/user-payment-verification"
                className={`text-decoration-none d-block py-2 ${isActive('/user-payment-verification') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
               Payment Verification
              </a>
            </li>
            <li>
              <a
                href="/widthrawl-requests"
                className={`text-decoration-none d-block py-2 ${isActive('/widthrawl-requests') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
               Widthdrawl Requests
              </a>
            </li>
            


          </ul>
        </div>

        {/* 3. Footer */}
        <div className="sidebar-footer p-3 text-center text-muted small">
          © 2025 Blackstone
        </div>
      </div>
    </nav>
  );
}

export default SideBar;
